namespace('compass.hotel');

compass.require('compass.hotel.StarRatingWidget');
compass.requireLib('compass.util.format');

compass.hotel.HotelHeaderWidget = compass.defineWidget(function HotelHeaderWidget(options) {
	var me = this;
	var d = jQuery.dom;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _hotel = _settings.hotel;
	var _ids = {
		hotelName: compass.generateId()
	};

	this.render = function(widgetElem) {
		var classes = 'hotelHeader hotel_id_' + _hotel.hotelId;

		widgetElem.append(
			d.div({ className : classes, tabindex : 0, 'aria-labelled': _ids.hotelName },
				me.drawHotelName(_hotel),
				me.drawTotalRooms(_hotel)
			)
		);
	};

	this.getHotel = function() {
		return _hotel;
	};

	this.drawHotelName = function(hotel) {
		return d.span({ className : 'hotelName'}, hotel.name);
	};

	this.drawTotalRooms = function(hotel) {
		return d.span({ className : 'hotelTotalRooms' },
			d.span({className: 'totalRoomsValue'}, hotel.totalRooms), _settings.labels.totalRoomsReserved
		);
	};

	this.setData = function(hotel){
		_hotel = hotel;
	};

	this.updateTotalRooms = function(totalRooms) {
		me.find('.hotelTotalRooms .totalRoomsValue').empty().append(totalRooms);
	};

}, {
	WUID : 'defaultHotelHeaderWidgetWUID',
	widgetName : 'HotelHeaderWidget',
	hotel : {},
	labels : {
		totalRoomsReserved : ' Rooms Reserved'
	}
});

